module.exports = __webpack_public_path__ + "static/media/sample_lmconsignee.1fdacf6c.csv";